module.exports = __webpack_public_path__ + "img/achieve5.ab3e5005.png";